export default __webpack_public_path__ + "logo184c5c13.png";